import { Theme, Typography } from '@mui/material'
import { CSSProperties, ReactNode } from 'react'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Schema } from './schema'

export const SingleAdViewTimeSoftValidator = (): ReactNode => {
  const SAFE_MINIMUM: number = 4_000

  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.richPlacements.multianchor.basicSettings.singleAdViewTime',
  })
  const { singleAdViewTime } = useWatch<Schema>()

  if (singleAdViewTime === undefined || singleAdViewTime >= SAFE_MINIMUM) {
    return undefined
  }

  return (
    <Typography
      color={(theme: Theme): CSSProperties['color'] => theme.palette.warning.main}
      component='span'
      variant='caption'
    >
      {t('recommendedMinimum')}
    </Typography>
  )
}
